(function (Drupal, drupalSettings, c3) {
    Drupal.behaviors.c3Charts = {
        attach: function (context, settings) {
            let chartContainers = document.querySelectorAll('.js-chart');

            if (!chartContainers) {
                return false;
            }

            chartContainers.forEach(function (container) {

                if(container.id.replace('chart-','') === ""){
                    return false;
                }

                let containerId = container.id,
                    //dataUrl = drupalSettings.charts[containerId].url, //CSV
                    chartType = drupalSettings.charts[containerId].type,
                    chartJson = drupalSettings.charts[containerId].json,
                    groupKeyZero = Object.keys(chartJson[0])[0],
                    groupKeyOne = Object.keys(chartJson[0])[1],
                    groupKeyTwo = Object.keys(chartJson[0])[2];

                //console.log(Object.keys(chartJson[0])[2]);

                let colors=["#005596", "#959ca1", "#fcb034", "#009641", "#0091ff", "#005596"];
                let options = {
                    default:{
                        bindto: document.getElementById(containerId),
                        data: {
                            type: chartType,
                            //url: dataUrl,
                            json: chartJson[0],
                        },
                        color: {
                            pattern: colors
                        },
                        legend:{
                            position:'right'
                        },
                        tooltip: {
                            format: {
                                value: function (value, ratio, id, index) { return value.toLocaleString() + " (" + (ratio*100).toFixed(1) + "%)"; }
                            }
                        },
                        pie:{
                            label: {
                                format: function (value) { return value.toLocaleString(); }
                            }
                        },
                        donut:{
                            label: {
                                format: function (value) { return value.toLocaleString(); }
                            }
                        }
                    },
                    bar:{
                        bindto: document.getElementById(containerId),
                        data: {
                            type: chartType,
                            //url: dataUrl,
                            json: chartJson,
                            x: groupKeyZero,
                            keys: {
                                x: groupKeyZero,
                                value : [groupKeyOne, groupKeyTwo]
                            },
                            groups: [
                                [groupKeyOne, groupKeyTwo]
                            ]
                        },
                        color: {
                            pattern: colors
                        },
                        bar: {
                            width: {ratio: 0.7}
                        },
                        grid: {
                            y: {
                                show: true
                            },
                        },
                        tooltip: {
                            format: {
                                value: function (value, ratio, id, index) { return value.toLocaleString(); }
                            }
                        },
                        axis: {
                            x: {
                                type: 'category',
                                tick: {
                                    centered: true,
                                    fit: true,
                                    multiline: false
                                },
                                label: {
                                    position: 'inner-center'
                                }
                            }
                        }
                    }
                }


                if (chartType === 'bar' || chartType === 'line') {
                    let chart = c3.generate(options.bar)
                }else{
                    let chart = c3.generate(options.default)
                }
            })
        }
    }
}(Drupal, drupalSettings, c3));